import './TestItem.css';
import React, { useState, useRef } from 'react';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

function TestItem({ test, onStart, onContinue, onResult }) {
    const [isPressed, setIsPressed] = useState(false);
    const pressTimeoutRef = useRef(null);
    const isDimmed = test.status === 'WAITING' || test.status === 'EXPIRED';
    const isClickable = ['READY', 'TESTING', 'EDITING', 'EVALUATED'].includes(test.status);

    const getTimeText = () => {
        const minutes = Math.round(test.question_sheet.time_limit / 60);
        return `${minutes}분`;
    };

    const getDateText = () => {
        if (!test.start_time) return '상시';
        const date = new Date(test.start_time);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}/${month}/${day}`;
    };

    const getStatusBadge = () => {
        switch (test.status) {
            case "WAITING":
                return { text: '대기중', type: 'default' };
            case "EXPIRED":
                return { text: '만료됨', type: 'default' };
            case "READY":
                return { text: '응시가능', type: 'primary' };
            case "TESTING":
            case "EDITING":
                return { text: '진행중', type: 'progress' };
            case "EVALUATING":
                return { text: '채점중', type: 'evaluating' };
            case "EVALUATED":
                return { text: '결과확인', type: 'completed' };
            default:
                return null;
        }
    };

    const handleClick = () => {
        if (!isClickable) return;

        setIsPressed(true);
        if (pressTimeoutRef.current) {
            clearTimeout(pressTimeoutRef.current);
        }
        pressTimeoutRef.current = setTimeout(() => {
            setIsPressed(false);
            switch (test.status) {
                case "READY":
                    onStart?.();
                    break;
                case "TESTING":
                case "EDITING":
                    onContinue?.();
                    break;
                case "EVALUATED":
                    onResult?.();
                    break;
                default:
                    break;
            }
        }, 80);
    };

    const statusBadge = getStatusBadge();

    return (
        <div
            className={`test-item ${isDimmed ? 'dimmed' : ''} ${isPressed ? 'pressed' : ''} ${!isClickable ? 'disabled' : ''}`}
            onClick={handleClick}
        >
            <div className="test-item-content">
                <div className="test-item-title-row">
                    <span className="test-item-title">{test.title}</span>
                    {statusBadge && (
                        <span className={`test-item-badge ${statusBadge.type}`}>
                            {statusBadge.type === 'evaluating' && <AutorenewIcon />}
                            {statusBadge.text}
                        </span>
                    )}
                </div>
                {test.description && (
                    <div className="test-item-desc">{test.description}</div>
                )}
                <div className="test-item-meta">
                    {test.question_sheet.number_of_questions}문항 · {getTimeText()} · {test.question_sheet.total_score}점
                </div>
                {test.academy_class_type !== 'L' && (
                    <div className="test-item-date">
                        <span className="test-item-date-icon">📅</span>
                        <span className="test-item-date-value">{getDateText()}</span>
                    </div>
                )}
            </div>
            {isClickable && (
                <div className="test-item-arrow">
                    <ChevronRightIcon />
                </div>
            )}
        </div>
    );
}

export default TestItem;
